import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import SectionGate from '../../../app/SectionGate';
import initialize from '../actions/initialize';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

// Init gate for the access-management section. Acts as a route
// layout: the section's sub-routes live in the consolidated route table
// (app/Main.tsx) and render through the <Outlet /> that SectionGate provides
// once initialized. The route table also handles the central_station role
// restriction (roles/security are hidden for that role).
const App = () => {
  const dispatch = useDispatch();
  const { initializing, initialized, error } = useSelector(
    state => state.appAccess,
  );
  useInitialize(dispatch);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!error}
      wrapper={AppInnerWrapper}
    />
  );
};
export default App;
